import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { IPopularMachineTypeBlockData } from './IPopularMachineTypeBlockData';

export const DynamicPopularMachineTypeBlock = dynamic<
    BlockProps<IPopularMachineTypeBlockData>
>(() =>
    import('./PopularMachineTypeBlock').then(md => md.PopularMachineTypeBlock),
);
